import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=6c2d7a50&scoped=true&"
import script from "./Name.vue?vue&type=script&lang=js&"
export * from "./Name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d7a50",
  null
  
)

export default component.exports